import { thunk } from "redux-thunk";
import { combineReducers } from "redux";
import { persistStore } from "redux-persist";
import { configureStore } from "@reduxjs/toolkit";
import { composeWithDevTools } from "redux-devtools-extension";

import {
  uiReducer,
  settingsReducer,
  consentPrivacyReducer,
  fileRequestsPublicReducer,
} from "../reducers";

import { equalsIgnoringCase } from "../../utils/validators";

const combinedReducers = combineReducers({
  // State Storage
  ui: uiReducer,
  // Session Storage
  settings: settingsReducer,
  // Local Storage
  consentPrivacy: consentPrivacyReducer,
  // Session Storage
  fileRequestsPublic: fileRequestsPublicReducer,
});

const store = configureStore(
  {
    reducer: combinedReducers,
    middleware: (getDefaultMiddleware) => [thunk],
    devTools: !equalsIgnoringCase(process.env.REACT_APP_ENV, "PRODUCTION"),
    trace: true,
  },
  composeWithDevTools()
);

const persistor = persistStore(store);

export { store, persistor };
